@if (initialized) {
    <div class="cn-model-comparison">

        <!-- ===================== EINGABE-PANEL ===================== -->
        <div class="surface-0 border-1 surface-border border-round p-3 mb-3">
            <div class="text-lg font-medium mb-3">Vergleich konfigurieren</div>

            <div class="grid">
                <!-- Aktiv-Modell -->
                <div class="col-12 md:col-6">
                    <div class="text-sm text-600 mb-1">Aktiv-Modell (Pflicht)</div>
                    @if (activeModelWidget) {
                        <mvs-widget
                                [widgetData]="activeModelWidget"
                                (onObjectSelect)="handleActiveModelSelect($event)">
                        </mvs-widget>
                    }
                </div>

                <!-- Szenario-Modelle -->
                <div class="col-12 md:col-6">
                    <div class="text-sm text-600 mb-1">Szenario-Modelle (Mehrfachauswahl)</div>
                    @if (scenarioModelWidget) {
                        <mvs-widget
                                [widgetData]="scenarioModelWidget"
                                (onObjectSelect)="handleScenarioModelSelect($event)">
                        </mvs-widget>
                    }
                    @if (scenarioModelIds.length) {
                        <div class="text-xs text-600 mt-1">
                            {{ scenarioModelIds.length }} Szenario(s) ausgewählt
                        </div>
                    }
                </div>
            </div>

            <!-- Bestandsfilter -->
            <div class="grid mt-2">
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-partner">Partner-ID</label>
                    <p-inputNumber id="cn-cmp-partner"
                                   [(ngModel)]="contractFilter.partnerId"
                                   [useGrouping]="false"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-group">Group-ID</label>
                    <p-inputNumber id="cn-cmp-group"
                                   [(ngModel)]="contractFilter.groupId"
                                   [useGrouping]="false"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-ctype">Vertragsart-ID</label>
                    <p-inputNumber id="cn-cmp-ctype"
                                   [(ngModel)]="contractFilter.contractTypeId"
                                   [useGrouping]="false"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-category">Kategorie-ID</label>
                    <p-inputNumber id="cn-cmp-category"
                                   [(ngModel)]="contractFilter.categoryId"
                                   [useGrouping]="false"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
            </div>

            <!-- Horizont / Diskontrate / Snapshot -->
            <div class="grid mt-2 align-items-end">
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-horizon">Horizont (Jahre)</label>
                    <p-inputNumber id="cn-cmp-horizon"
                                   [(ngModel)]="horizonYears"
                                   [min]="1" [max]="30"
                                   (ngModelChange)="rebuildForecastRows()"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
                <div class="col-6 md:col-3">
                    <label class="text-sm text-600" for="cn-cmp-discount">Diskontrate (%)</label>
                    <p-inputNumber id="cn-cmp-discount"
                                   [(ngModel)]="discountRatePercent"
                                   [minFractionDigits]="0" [maxFractionDigits]="2"
                                   styleClass="w-full">
                    </p-inputNumber>
                </div>
                <div class="col-6 md:col-3">
                    <div class="flex align-items-center gap-2">
                        <p-toggleSwitch [(ngModel)]="useForecast"></p-toggleSwitch>
                        <span class="text-sm">Forecast je Jahr (A7)</span>
                    </div>
                </div>
                <div class="col-6 md:col-3">
                    <div class="flex align-items-center gap-2">
                        <p-toggleSwitch [(ngModel)]="persistDecisionSnapshot"></p-toggleSwitch>
                        <span class="text-sm">Snapshot speichern</span>
                    </div>
                </div>
            </div>

            <!-- Forecast-Tabelle (optional, A7) -->
            @if (useForecast) {
                <div class="mt-3">
                    <div class="text-sm font-medium mb-2">Forward-Annahmen je Horizontjahr</div>
                    <p-table [value]="forecastRows" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Jahr</th>
                                <th>Projizierte Quote</th>
                                <th>Angenommenes YoY (%)</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ row.year }}</td>
                                <td>
                                    <p-inputNumber [(ngModel)]="row.projectedQuota"
                                                   [minFractionDigits]="0" [maxFractionDigits]="2"
                                                   styleClass="w-full">
                                    </p-inputNumber>
                                </td>
                                <td>
                                    <p-inputNumber [(ngModel)]="row.assumedYoY"
                                                   [minFractionDigits]="0" [maxFractionDigits]="2"
                                                   styleClass="w-full">
                                    </p-inputNumber>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            }

            <!-- Start -->
            <div class="flex justify-content-end mt-3">
                <p-button label="Vergleich starten"
                          icon="fa-regular fa-scale-balanced"
                          [disabled]="!canStart()"
                          [loading]="state === 'busy'"
                          (onClick)="startComparison()">
                </p-button>
            </div>
        </div>

        <!-- ===================== BUSY / PROGRESS ===================== -->
        @if (state === 'busy') {
            <div class="surface-0 border-1 surface-border border-round p-3 mb-3">
                <div class="text-sm text-600 mb-2">Vergleich läuft…</div>
                <p-progressBar [value]="progress"></p-progressBar>
            </div>
        }

        <!-- ===================== ERROR ===================== -->
        @if (state === 'error') {
            <p-message severity="error" class="block mb-3" [text]="errorMessage"></p-message>
        }

        <!-- ===================== READY: RESULT + SNAPSHOT ===================== -->
        @if (state === 'ready' && result) {
            <mvs-cn-model-comparison-result
                    [result]="result"
                    [modelLabels]="modelLabels">
            </mvs-cn-model-comparison-result>

            @if (snapshotId) {
                <div class="mt-3">
                    <mvs-cn-decision-snapshot [snapshotId]="snapshotId"></mvs-cn-decision-snapshot>
                </div>
            }
        }

        <!-- ===================== EMPTY ===================== -->
        @if (state === 'idle') {
            <div class="text-center text-600 p-5">
                Wählen Sie ein Aktiv-Modell und mindestens ein Szenario, um den Vergleich zu starten.
            </div>
        }

    </div>
}
